module.exports = __webpack_public_path__ + "img/logo-m-fundo-transparente-m-branco.0a427f66.png";